import Vue from 'vue';
import Vuex from 'vuex';
import productCategories from '@js/v2/src/config/products/product-categories';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        environment: {
        },
        bpayBillerCode: '275909',
        clientHasCreditCard: '',
        clientHasVerifiedPayment: '',
        creditCardImage: '',
        paymentMethodSelected: '',
        clientHasActivePaypalBA: '',
        clientActivePaypalBAEmail: '',
        displayProfileUpdateForm: false,
        isEditingAccountHolderProfile: false,
        isOnAccountPage: false,
        invoice: {},
        displayEmailUpdateForm: false,
        paymentView:false,
        userDetails: {},
        userFeatures: {},
        accountHolder: {},
        contactAvatar:'/img/avatar.svg',
        profileWidget:{},
        serviceSupportAction: false,
        currentService: {},
        userHasVerified: {
            isActive:true,
            title: 'Account verification',
            msg: "In order to purchase Services with Servers Australia, we'll first need to verify your account.",
            link:'verify'
        },
        remoteManagement: {},
        icons: {
            'dedicated-server': 'icon-sau-dedicated',
            'cloud': 'icon-sau-cloud',
            'colocation': 'icon-sau-colocation',
            'transit': 'icon-sau-transit',
            'ssl': 'icon-sau-ssl',
            'firewall': 'icon-sau-firewall',
            'managed-wordpress': 'icon-sau-wordpress',
            'hadraas': 'icon-sau-hadraas',
            'management-pack': 'icon-sau-management-pack',
            'load-balancer': 'icon-sau-load-balancer',
            'domain': 'icon-sau-domains',
            'other': 'icon-sau-products',
            'legacy': 'icon-sau-legacy',
            'vps-oa': 'icon-sau-cloud',
            'vps-xs': 'icon-sau-cloud',
            'vps': 'icon-sau-cloud',
            'vds': 'icon-sau-cloud',
            'cross-connect': 'far fa-exchange-alt mt-5',
            'ssl-certificate': 'far fa-lock-alt mt-3',
            'private-cloud': 'icon-sau-cloud',
            'virtual-data-centre': 'fa fa-chart-network',
            'nimble': 'fal fa-warehouse-alt'
        },
        off: {
            start: 'This action will power on your server',
            stop: 'Your server is currently powered off',
        },
        on: {
            start: 'Your server is currently powered on',
            stop: 'This will perform a graceful shutdown',
            force: 'This will perform a force shutdown',
        },
        messages: {
            reboot: 'This will attempt to perform a force reboot',
            shutdown: 'This will perform a force shutdown',
            off: 'This action will attempt a graceful power shutdown of your server',
            on: 'This action will power on your server',
            force: 'This will immediately power off the server',
            cycle: 'This will perform a cold reboot',
            reset: 'This will attempt to perform a warm reboot',
            rebuild: 'This will rebuild the VPS',
            'force-shutdown': 'This will force shutdown the VPS',
            'force-reboot': 'This will force the VPS to reboot',
            stop: 'This action will attempt a graceful power shutdown of your server',
            start: 'This action will power on your server',
            guestreboot: 'This will attempt to perform a graceful reboot of your server',
        },
        actions: {
            reboot: 'Performing Force Reboot!',
            gracefulreboot: 'Performing Reboot!',
            shutdown: 'Performing Force Shutdown!',
            off: 'Powering Off!',
            on: 'Powering On!',
            force: 'Forcing Power Off!',
            cycle: 'Cycling Power!',
            reset: 'Resetting!',
            rebuild: 'Rebuilding!',
            'force-reboot': 'Forcing VPS to Reboot!',
            'force-shutdown': 'Shutting Down VPS!',
            stop: 'Stopping VPS',
            start: 'Starting VPS!',
        },
        overdueServices: [],
        productCategories: productCategories.filter((category) => !category.disabled),
        loadingStates: {
            overdueServices: false,
        },

    },
    getters:{
        guestAccessEnabled: state => {
            return state.remoteManagement.thirdpartyPassword && state.remoteManagement.thirdpartyUser ? true : false;
        },
        hasRemoteManagement: state => {
            return Object.keys(state.remoteManagement).length ? true : false;
        },
        ccLastFour: state => {
            return state.userDetails.billing.card_last_four;
        },
        isOnAccountPage: state => {
            return state.isOnAccountPage = window.location.href.indexOf('account') > -1;
        },
        canUpdatePaymentOptions: state => {
            return state.canUpdatePaymentOptions = window.location.href.indexOf('payment-options') > -1;
        }
    },
    mutations:{
        setEnvironment(state, payload){
            state.environment = payload
        },
        setCreditCardLastFour(state, payload) {
            state.userDetails.billing.card_last_four = payload;
        },
        setCreditCardImage(state, payload) {
            state.creditCardImage = payload;
        },
        setCreditCardExp(state, payload) {
            state.userDetails.billing.card_exp = payload;
        },
        setCreditCardType(state, payload) {
            state.userDetails.billing.card_type = payload;
        },
        paymentMethodSelected(state, payload) {
            state.paymentMethodSelected = payload;
        },
        paypalActiveBAOnFile(state, payload) {
            state.clientHasActivePaypalBA = payload;
        },
        paypalActiveBAEmail(state, payload) {
            state.clientActivePaypalBAEmail = payload;
        },
        setUserDetails(state, payload) {
            state.userDetails = payload;
        },
        updateUserDetails(state, payload) {
            for(var prop in state.userDetails){
                if(payload[prop] !== undefined){
                    Vue.set(state.userDetails, prop, payload[prop]);
                }
            }
        },
        setAccountPin(state, payload) {
            state.userDetails.account_pin = payload;
        },
        setUserFeatures(state, payload) {
            state.userFeatures = payload;
        },
        setIndividualUserFeature(state, payload) {
            Vue.set(state.userFeatures, payload[0], payload[1]);
        },
        setServiceSupportAction(state, payload) {
            state.serviceSupportAction = payload;
        },
        setRemoteManagement(state, payload) {
            state.remoteManagement = payload;
        },
        setProfileWidget(state, payload) {
            state.profileWidget = payload;
        },
        setPaymentView(state, payload) {
            state.paymentView = payload;
        },
        setThirdPartyAccess(state, payload) {
            let array = Object.entries(payload);
            Vue.set(state.remoteManagement, array[0][0], array[0][1]);
            Vue.set(state.remoteManagement, array[1][0], array[1][1]);
        },
        setDirectAccess(state, payload) {
            Vue.set(state.remoteManagement, payload[0], payload[1]);
        },
        setAccountHolder(state, payload) {
            state.accountHolder = payload;
        },
        updateAccountHolder(state, payload) {
            for(var prop in state.userDetails){
                if(payload[prop] !== undefined){
                    Vue.set(state.accountHolder, prop, payload[prop]);
                }
            }
        },
        setDisplayProfileUpdateForm(state, payload) {
            state.displayProfileUpdateForm = payload;
        },
        setIsEditingAccountHolderProfile(state, payload) {
            state.isEditingAccountHolderProfile = payload
        },
        setDisplayEmailUpdateForm(state, payload) {
            state.displayEmailUpdateForm = payload;
        },
        setUserField(state, payload) {
            Vue.set(state.userDetails, payload[0], payload[1]);
        },
        // Save service object passed as prop so the details can be access from the side support bar
        setCurrentService(state, payload) {
            state.currentService = payload;
        },
        setInvoice(state, payload) {
            state.invoice = payload;
        },
        setUserCredit(state, payload) {
            state.userDetails.billing.credit = payload;
        },
        setActiveSidebar(state, payload) {
            state.activeSidebar = payload;
        },
        setOverdueServices(state, payload) {
            state.overdueServices = payload;
        },
        setLoadingState(state, payload) {
            state.loadingStates[payload.key] = payload.value;
        },
    },
    actions: {
        getOverdueServices(context) {
            context.commit('setLoadingState', { key: 'overdueServices', value: true });
            return axios.get('/api/v2/services/overdue').then((response) => {
                context.commit('setOverdueServices', response.data);
                return true;
            })
            .finally(() => {
                context.commit('setLoadingState', { key: 'overdueServices', value: false });
            });
        },
    }
});
